import * as contentful from 'contentful'

export const client = contentful.createClient({
  space: 'w5a9zk6np1yc',
  accessToken: 'lsC-sO20eorrxrSg0Ojj-mJ0X8Yex0ocieyA9yZpCd8'
})